import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import { displayCorrectContent, getSizeOfUpload, verifyToNotSaveToStorage, verifyToStorage } from "helpers/helpers";

export default function AttachFile({ title, id, setFieldValue, value, error, touched, obligatoriu=false }) {
   const [fileName, setFileName] = useState("Alege Document");
   const uploadedValue = displayCorrectContent(value);

   const handleRemoveImage = () => {
      setFieldValue(id, null);
      setFileName("Alege Document");
   };

   return (
      <>
         <div className="col-md-12 attach-file-container">
            <h2>{title} <span className="optional"> ({obligatoriu ? 'obligatoriu' : 'optional' })</span></h2>
            <label id={id} className="w-100">
               <div className="attach-file">
                  <div>
                     <img src={require("assets/images/attach.png")} alt="attach_img" />
                     <span className="ms-3">{fileName}</span>
                  </div>
                  <span>*pdf, png, jpg, jpeg, doc</span>
               </div>
               <input
                  type={"file"}
                  id={id}
                  name={id}
                  className="hidden"
                  onChange={async event => {
                     let uploadedFile = event.target.files[0];
                     setFileName(event.target.files[0].name);

                     const fileSizeInMB = await getSizeOfUpload(uploadedFile);
                     let fileToPersistOrNot = null;
                     if (fileSizeInMB > 1) fileToPersistOrNot = await verifyToNotSaveToStorage(uploadedFile);
                     else fileToPersistOrNot = await verifyToStorage(uploadedFile);

                     setFieldValue(id, fileToPersistOrNot);
                  }}
               />
            </label>
         </div>
         <div>
            {uploadedValue.imageToDisplay !== null
               && uploadedValue.imageToDisplay !== undefined
               && uploadedValue.imageToDisplay !== '' && (
               <button type="button" className="delete-button" onClick={() => handleRemoveImage()}>
                  Sterge
               </button>
            )}

            {uploadedValue.isPdf ? (
               <Document file={uploadedValue.imageToDisplay}>
                  <Page pageNumber={1} />
               </Document>
            ) : (
               <img className="ss-prew" src={uploadedValue.imageToDisplay} />
            )}
         </div>

         {error && touched && <div className="text-center error-msg">{error}</div>}
      </>
   );
}
